import * as React from "react";

import { FormattedMessage } from "react-intl";
import { Button } from "react-bootstrap";
import Confirm from "../../../../general/Confirm";
import { ListDeleteFunction, ListDeleteTracking } from "shared/src/types/ListItemRenderData";

type ItemData = {
    variantId: string | undefined | null;
    originalBundleId: string | undefined | null;
    bettyBundleId: string | undefined | null;
};

type DeleteData = {
    listId: string | undefined | null;
    listType: string | undefined | null;
    listName: string | undefined | null;
    deleteAction: ListDeleteFunction | undefined | null;
    deleteTracking: ListDeleteTracking | undefined | null;
};

type Props = {
    itemData: ItemData;
    showDeleteButton: boolean;
    deleteData: DeleteData;
};

function DeleteFromListButton(props: Props) {
    if (!props.showDeleteButton) {
        return null;
    }
    return (
        <div className={"mfcss_card-article-2--secondary-actions-delete"}>
            <Confirm.Trigger
                confirm={() => {
                    deleteOneItem(props.itemData, props.deleteData);
                }}
                message={<FormattedMessage id="EX_ASK_TO_REMOVE" />}
                abortBtn={<FormattedMessage id="EX_CANCEL_MODAL" />}
                confirmBtn={<FormattedMessage id="EX_REMOVE" />}>
                <Button className={"btn-link"}>
                    <i className={"icon-trash"} />
                    <FormattedMessage id="EX_REMOVE" />
                </Button>
            </Confirm.Trigger>
        </div>
    );
}

function deleteOneItem(itemData: ItemData, deleteData: DeleteData): void {
    const data = {
        articleVariantId: itemData.variantId,
        parentBettyBundleId: itemData.originalBundleId,
        bettyBundleId: itemData.bettyBundleId
    };
    if (!deleteData.deleteAction) {
        return;
    }
    deleteData.deleteAction(data, {
        listId: deleteData.listId,
        listType: deleteData.listType,
        listName: deleteData.listName
    });
    if (!deleteData.deleteTracking) {
        return;
    }
    deleteData.deleteTracking(
        deleteData.listType || undefined,
        deleteData.listId || undefined,
        itemData.originalBundleId || undefined,
        undefined
    );
}

export default DeleteFromListButton;
